module.exports = __webpack_public_path__ + "img/charging-pile1.e7ae8818.png";